import { render } from "./PersonalLanding.vue?vue&type=template&id=4d356aa2&scoped=true"
import script from "./PersonalLanding.vue?vue&type=script&lang=js"
export * from "./PersonalLanding.vue?vue&type=script&lang=js"

import "./PersonalLanding.vue?vue&type=style&index=0&id=4d356aa2&lang=css"
import "./PersonalLanding.vue?vue&type=style&index=1&id=4d356aa2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d356aa2"]])

export default __exports__